import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { APIGetResponse } from './types';
import { axiosBaseQuery } from './baseQuery';

const EDITING_GROUP_URL = `/api/editing-groups`;

export const editingGroupApi = createApi({
  reducerPath: 'editingGroup.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['editingGroup'],
  endpoints: (builder) => ({
    getEditingGroups: builder.query({
      query: ({ pageNo = 0, pageSize = DEFAULT_ROWS_PER_PAGE, searchKey = '' }) => ({
        url: `${EDITING_GROUP_URL}?pageNo=${pageNo}&pageSize=${pageSize}&searchKey=${searchKey}`,
      }),
      transformResponse: (response, meta: any): APIGetResponse => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        };
      },
      providesTags: ['editingGroup'],
    }),
    getEditingGroupById: builder.query({
      query: (id) => ({ url: `${EDITING_GROUP_URL}/${id}` }),
      providesTags: ['editingGroup'],
    }),
    addEditingGroup: builder.mutation({
      query: (body) => ({
        url: `${EDITING_GROUP_URL}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['editingGroup'],
    }),
    deleteEditingGroup: builder.mutation({
      query: (id) => ({
        url: `${EDITING_GROUP_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['editingGroup'],
    }),
    updateEditingGroup: builder.mutation({
      query: (data) => ({
        url: `${EDITING_GROUP_URL}/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['editingGroup'],
    }),
  }),
});

export const {
  useGetEditingGroupsQuery,
  useGetEditingGroupByIdQuery,
  useAddEditingGroupMutation,
  useDeleteEditingGroupMutation,
  useUpdateEditingGroupMutation,
} = editingGroupApi;
